import { useEffect } from 'react'

import BaseBridge from 'config/bridge/BaseBridge'
import useBoundState from 'store'
import { typeIcons } from 'store/navbar/types'

interface NavBarProps {
  navbarTitle?: string
  actionIcons?: typeIcons
  backListener?: () => void
  backButtonCallback?: () => void
  helpButtonCallback?: () => void
  backTicName?: string
}

export const useNavBar = ({
  navbarTitle,
  actionIcons,
  backListener,
  backButtonCallback,
  helpButtonCallback,
  backTicName,
}: NavBarProps) => {
  const setNavbarTitle = useBoundState((state) => state.setNavbarTitle)
  const setActionIcon = useBoundState((state) => state.setActionIcons)
  const setBackListener = useBoundState((state) => state.setBackListener)
  const setBackButtonCallback = useBoundState((state) => state.setBackButtonCallback)
  const setHelpButtonCallback = useBoundState((state) => state.setHelpButtonCallback)
  const setBackTicName = useBoundState((state) => state.setBackTicName)
  const contentTitle = useBoundState((state) => state.contentCapitalization)

  useEffect(() => {
    setNavbarTitle(navbarTitle ?? contentTitle.value1)

    if (backButtonCallback) {
      setBackButtonCallback(backButtonCallback)
    }

    if (helpButtonCallback) {
      setHelpButtonCallback(helpButtonCallback)
    }

    if (backListener) {
      setBackListener(backListener)
      BaseBridge.addBackListener(backListener)
    }

    if (actionIcons) {
      setActionIcon(actionIcons)
    }

    if (backTicName) {
      setBackTicName(backTicName)
    }
  }, [])
}
